export const environment = {
  production: true,
  useMockData: false,
  apiUrl: 'https://api-gateway.tegalhub.com/prod-api-passport-medical/v1/front',
  refUrl: 'https://referential-pro-api.paas.tegalhub.com',
  uploadApiUrl: 'https://passport-api.paas.tegalhub.com/passeport/documents/upload',
  appName: 'Passeport Medical',
  version: '1.0.0',

  // Configuration du thème
  theme: {
    default: 'eyone', // 'eyone' ou 'dpp'
  },

  // Configuration des timeouts
  httpTimeout: 60000, // 60 secondes en production

  // Configuration des retry
  maxRetries: 2,
  retryDelay: 2000, // 2 secondes

  // Configuration des logs
  enableLogs: false,
  logLevel: 'error',

  // Configuration de l'authentification
  auth: {
    tokenKey: 'passeport_token',
    refreshTokenKey: 'passeport_refresh_token',
    tokenExpiryKey: 'passeport_token_expiry',
    autoRefresh: true,
    refreshThreshold: 5 * 60 * 1000, // 5 minutes avant expiration
  },

  // Configuration des uploads
  upload: {
    maxFileSize: 20 * 1024 * 1024, // 20MB en production
    allowedTypes: [
      'image/*',
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
    maxFiles: 10,
  },

  // Configuration des notifications
  notifications: {
    position: 'top-right',
    duration: 3000,
    enableSound: true,
  },

  // Configuration des features
  features: {
    enableOfflineMode: true,
    enablePushNotifications: true,
    enableAnalytics: true,
  },

  // Configuration OneSignal Web Push
  oneSignal: {
    appId: '',
    safariWebId: '',
    serviceWorkerPath: 'OneSignalSDKWorker.js',
    serviceWorkerUpdaterPath: 'OneSignalSDKUpdaterWorker.js',
    sdkUrl: 'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js',
    allowLocalhostAsSecureOrigin: true,
  },

  // Configuration Google Maps
  googleMaps: {
    apiKey: 'AIzaSyDbOznBcfBFHISn0i381WED65meKHTRlhg',
    defaultZoom: 15,
    defaultHeight: '200px',
  },
  paymentToken: 'test_public-52ea4aba-8343-4362-87b4-cba7aeb54731.F9zzFQmHyVEyDv9sGfxwJWXEScwGDIccKSBpKZuyDIobK1YAnAsUUVMFmDhiYClc',

  /** Liens de téléchargement des applications mobiles (page /liens) */
  appStoreUrl: 'https://apps.apple.com/sn/app/eyone-passeport-medical/id1631393669',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.passeportsante.eyone',
};
